import { render, staticRenderFns } from "./Gerenkc.vue?vue&type=template&id=4b343e6e&scoped=true"
import script from "./Gerenkc.vue?vue&type=script&lang=js"
export * from "./Gerenkc.vue?vue&type=script&lang=js"
import style0 from "./Gerenkc.vue?vue&type=style&index=0&id=4b343e6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b343e6e",
  null
  
)

export default component.exports